import React, {useMemo} from 'react';
import EditableTable from '../editableTable/editableTable';
import CustomModal from '../../../../../../../../components/custom-modal/custom-modal';

const HSR = ({
  setShow,
  show,
  assessment,
  hsrOptions,
  hsrAssessments,
  createHSR,
  deleteHSR,
  isCreating,
  isDeleting,
}) => {
  
  const isOptionSelected = (optionId) => {
    return hsrAssessments.some(assessment => assessment.hsr_option === optionId);
  };

  const findAssessmentByOption = (optionId) => {
    return hsrAssessments.find(assessment => assessment.hsr_option === optionId);
  };

  const finalScore = useMemo(() => {
    return hsrAssessments.reduce((acc, assessment) => {
      const option = hsrOptions?.find(opt => opt.id === assessment.hsr_option);
      return acc + (option?.score || 0);
    }, 0);
  }, [hsrAssessments, hsrOptions]);

  const handleCheckBoxChange = async (e, optionId) => {
    const checked = e.target.checked;

    if (checked) {
     
      await createHSR([{ hsr_option: optionId }]);
    } else {
     
      const existingAssessment = findAssessmentByOption(optionId);
      if (existingAssessment) {
        await deleteHSR(existingAssessment.id);
      }
    }
  };

  
  const tableHeaders = ['No.', 'Criteria', 'Score', 'Action'];
  const tableKeys = ['id', 'criteria', 'score', 'action'];

  const tableData = hsrOptions?.map((option, index) =>
    tableKeys?.map(key => {
      const value = option[key];
      const score = option['score'];

      if (key === 'action' && score > 0) {
        return (
          <input
            onChange={e => handleCheckBoxChange(e, option.id)}
            checked={isOptionSelected(option.id)}
            type="checkbox"
            disabled={isCreating || isDeleting}
          />
        );
      } else if (key === 'id') {
        return index + 1;
      } else if (key === 'score') {
        return score > 0 ? value : '';
      } else {
        return value;
      }
    }),
  );

  return (
    <CustomModal title="HSR" show={show} setShow={setShow}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          justifyItems: 'start',
          textAlign: 'start',
          fontSize: '18px',
          marginBottom: '16px',
        }}>
        <span>HSR Assessment</span>
        <span>Control System Category: Category {assessment?.category}</span>
        
        
        {/* HSR Score at Top */}
        {finalScore > 0 && (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            padding: '0.75rem',
            backgroundColor: '#e3f2fd',
            borderRadius: '5px',
            border: '1px solid #2196f3',
            marginTop: '0.5rem'
          }}>
            <span style={{fontWeight: 'bold', fontSize: '18px', color: '#1976d2'}}>
              HSR Score: {finalScore}
            </span>
          </div>
        )}
      </div>

      <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
        <EditableTable headers={tableHeaders} data={tableData} />

        {(isCreating || isDeleting) && (
          <div className="text-center" style={{fontSize: '14px', color: '#666'}}>
            {isCreating ? 'Saving...' : 'Deleting...'}
          </div>
        )}
      </div>
    </CustomModal>
  );
};

export default HSR;
